import { render } from "./Header.vue?vue&type=template&id=44f85c24&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=44f85c24&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f85c24"]])

export default __exports__